import React, { useState, useEffect } from "react"

//mapbox
import "mapbox-gl/dist/mapbox-gl.css"

//PrimeReact
import { Button } from "primereact/button"
import { ListBox } from "primereact/listbox"
import { Checkbox } from "primereact/checkbox"

//Referal modules
import RefTextInput from "../../Input/RefTextInput"
import RefDropDown from "../../Input/RefDropDown"
import ReferralEntityFormPlacesInput from "../ReferralEntityFormPlacesInput"
import ReferralEntityFormMap from "./ReferralEntityFormMap"

//Style
import refEntityStyles from "../../../../../styles/referrals/ReferralEntityForm.module.css"
import refStyles from "../../../../../styles/Referrals.module.css"
import formStyles from "../../../../../styles/Form-Inputs.module.css"

// Resources
import us_states from "../../../../../resources/us_states.json"
import RefCheckBox from "../../Input/RefCheckboxInput"
import ReferralEntityFormLocationsCategories from "./ReferralEntityFormLocationsCategories"

export default function ReferralEntityFormLocations({
  isInitialLoad,
  values,
  errors,
  isLoading,
  isReadOnly,
  serviceCategories,
  isNew,
  allowNewLocation,
  returnLocationId,
  GetFormField,
  onSetSelectedLocation,
}) {
  //const locationTypes = props.locationTypes

  const [locationCount, setLocationCount] = useState()
  const [selectedId, setSelectedId] = useState()
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (selectedId) {
      const index = values.referralLocations.findIndex(
        (x) => x.location.id === selectedId
      )
      setIndex(index)
    } else {
      if (values.referralLocations.length > 0) {
        setSelectedId(values.referralLocations[0].location.id)
      }
    }
  }, [selectedId, locationCount, values.referralLocations])

  const refLocationTemplate = (option) => {
    const index = values.referralLocations.findIndex(
      (x) => x.location.id === option.location.id
    )

    let hasErrors = false

    if (errors.referralLocations) {
      hasErrors = errors.referralLocations[index]
    }

    return (
      <div>
        <div style={{ display: "flex" }}>
          <span className="material-icons" style={{ marginRight: "5px" }}>
            {!!option.location.virtual ? "language" : "house"}
          </span>
          {option.location.name === "" ? "<No name>" : option.location.name}{" "}
        </div>
        {hasErrors ? (
          <div>
            <label> Incomplete! </label>{" "}
          </div>
        ) : null}
      </div>
    )
  }

  function addNewLocation() {
    let newId = -1

    if (values.referralLocations.length > 0) {
      const minIdValue = values.referralLocations.reduce((a, b) =>
        a.location.id < b.location.id ? a : b
      )
      newId = minIdValue.location.id < 0 ? minIdValue.location.id - 1 : -1
    }

    values.referralLocations.push({
      location: {
        id: newId,
        referralEntityId: values.referralEntity.id,
        name: "",
        noAddress: false,
        country: "United States",
        address: "",
        city: "",
        state: "",
        zipcode: "",
        noPhone: false,
        phone: "",
        noEmail: false,
        email: "",
        status: "Active",
        longitude: undefined,
        latitude: undefined,
        virtual: false,
      },
      serviceTypes: [],
    })

    if (!values?.referralEntity?.primaryLocationId) {
      values.referralEntity.primaryLocationId = newId
    }

    setSelectedId(newId)
    setLocationCount(values.referralLocations.length)
  }

  function removeNewLocation() {
    const removeIndex = index
    const removeId = values.referralLocations[index].location.id
    const NewSelectedindex =
      removeIndex <= values.referralLocations.length && removeIndex >= 1
        ? removeIndex - 1
        : 0

    setIndex(NewSelectedindex)
    setSelectedId(
      values.referralLocations[
        NewSelectedindex === 0 && NewSelectedindex === removeIndex
          ? 1
          : NewSelectedindex
      ].location.id
    )
    values.referralLocations = values.referralLocations.filter(
      (x) => x !== values.referralLocations[removeIndex]
    )

    if (values.referralEntity.primaryLocationId === removeId) {
      values.referralEntity.primaryLocationId =
        values.referralLocations[0].location.id
    }

    setLocationCount(values.referralLocations.length)
  }

  const locationStatus = [
    { label: "Active", value: "Active" },
    { label: "Suspended", value: "Suspended" },
    { label: "Inactive", value: "Inactive" },
  ]

  return (
    <div className={refEntityStyles.AddressContainer}>
      <div className={refEntityStyles.AddressListContainer}>
        <ListBox
          options={values.referralLocations}
          optionValue="location.id"
          value={selectedId}
          onChange={(e) => setSelectedId(e.value)}
          className={refEntityStyles.AddressList}
          filter
          itemTemplate={refLocationTemplate}
          disabled={isLoading}
        />
        <Button
          label="Add new location"
          icon="pi pi-plus"
          type="button"
          className={refEntityStyles.button}
          style={{ marginTop: "5px" }}
          onClick={() => {
            addNewLocation()
          }}
          disabled={isLoading || !allowNewLocation || isReadOnly}
        />
      </div>
      {values.referralLocations.length > 0 ? (
        <div className={refEntityStyles.AddressDetail}>
          <div className={refEntityStyles.header}>
            {values?.referralLocations[index]?.location.id < 0 &&
            values?.referralLocations?.length > 1 ? (
              <div style={{ display: "flex" }}>
                <div style={{ width: "80%" }}>
                  <RefTextInput
                    name={`referralLocations[${index}].location.name`}
                    label="Location name"
                    placeholderText="Name"
                    isInitialLoad={isInitialLoad}
                    disabled={isLoading || isReadOnly}
                    required={true}
                    helpText="The name of this location"
                  />
                </div>
                <div style={{ width: "20%", display: "flex" }}>
                  <Button
                    label="Remove"
                    icon="pi pi-times"
                    type="button"
                    className={refEntityStyles.button}
                    style={{
                      top: "47px",
                      marginLeft: "10px",
                      height: "42px",
                    }}
                    onClick={() => {
                      removeNewLocation()
                    }}
                    disabled={isLoading || isReadOnly}
                  />
                  <Button
                    icon="pi pi-plus"
                    type="button"
                    className={refEntityStyles.button}
                    style={{
                      top: "47px",
                      marginLeft: "5px",
                      height: "42px",
                      width: "55px",
                    }}
                    onClick={() => {
                      addNewLocation()
                    }}
                    disabled={isLoading || allowNewLocation || isReadOnly}
                    tooltip="Add new location"
                  />
                </div>
              </div>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ width: "95%" }}>
                  <GetFormField locationId={selectedId} name={"name"}>
                    <RefTextInput
                      name={`referralLocations[${index}].location.name`}
                      label="Location name"
                      placeholderText="Name"
                      isInitialLoad={isInitialLoad}
                      disabled={isLoading || isReadOnly}
                      required={true}
                      helpText="The identifying name of this location"
                    />
                  </GetFormField>
                </div>
                <div>
                  <Button
                    icon="pi pi-plus"
                    type="button"
                    className={refEntityStyles.button}
                    style={{ top: "47px", marginLeft: "10px" }}
                    onClick={() => {
                      addNewLocation()
                    }}
                    disabled={isLoading || !allowNewLocation || isReadOnly}
                    tooltip="Add new location"
                  />
                </div>
              </div>
            )}

            <RefDropDown
              name={`referralLocations[${index}].location.virtual`}
              label={"Location type"}
              helpText={"Specify if this is a physical or virtual location"}
              options={[
                { label: "Physical", value: false },
                { label: "Virtual", value: true },
              ]}
            />

            {isNew ? (
              <div className={formStyles.field}>
                <div>
                  <label>Selected location</label>
                </div>
                <div>
                  <Checkbox
                    checked={selectedId === returnLocationId}
                    onChange={(e) => {
                      if (e.checked && selectedId !== returnLocationId) {
                        onSetSelectedLocation(selectedId)
                      } else {
                        onSetSelectedLocation(null)
                      }
                    }}
                    className={refStyles.checkBox}
                    disabled={isLoading || isReadOnly}
                  />
                </div>
                <div>
                  <small style={{ color: "gray" }}>
                    Is this the location for the current referral?
                  </small>
                </div>
              </div>
            ) : null}

            {!!values.referralEntity.id ? (
              <GetFormField locationId={selectedId} name={"status"}>
                <RefDropDown
                  name={`referralLocations[${index}].location.status`}
                  label="Status"
                  placeholderText="Status"
                  isInitialLoad={isInitialLoad}
                  disabled={isLoading || isReadOnly}
                  options={locationStatus}
                  helpText="The status of the location"
                />
              </GetFormField>
            ) : null}

            <RefCheckBox
              name={`referralLocations[${index}].location.noPhone`}
              label="No phone number available"
              disabled={isLoading || isReadOnly}
              helpText="Check this option if no telephone number is available for the partner."
            />

            {!!values?.referralLocations[index] &&
            !values?.referralLocations[index]?.location.noPhone ? (
              <GetFormField locationId={selectedId} name={"phone"}>
                <RefTextInput
                  name={`referralLocations[${index}].location.phone`}
                  label="Phone"
                  mask="(999) 999-9999"
                  placeholderText="Phone"
                  isInitialLoad={isInitialLoad}
                  disabled={isLoading || isReadOnly}
                  required={true}
                  helpText="The telephone number for this location"
                />
              </GetFormField>
            ) : null}

            <RefCheckBox
              name={`referralLocations[${index}].location.noEmail`}
              label="No e-mail address available"
              disabled={isLoading || isReadOnly}
              helpText="Check this option if no e-mail address is available for the location."
            />

            {!!values?.referralLocations[index] &&
            !values?.referralLocations[index]?.location.noEmail ? (
              <GetFormField locationId={selectedId} name={"email"}>
                <RefTextInput
                  name={`referralLocations[${index}].location.email`}
                  label="E-mail"
                  placeholderText="E-mail"
                  isInitialLoad={isInitialLoad}
                  disabled={isLoading || isReadOnly}
                  required={true}
                  helpText="The e-mail address for this location"
                />
              </GetFormField>
            ) : null}

            {!!values.referralEntity.id ? (
              <GetFormField locationId={selectedId} name={"status"}>
                <RefDropDown
                  name={`referralLocations[${index}].location.status`}
                  label="Status"
                  placeholderText="Status"
                  isInitialLoad={isInitialLoad}
                  disabled={isLoading || isReadOnly}
                  options={locationStatus}
                  helpText="The status of the location"
                />
              </GetFormField>
            ) : null}
            <div className={`${refEntityStyles.webField}`}>
              <div className={refEntityStyles.webInput}>
                <GetFormField locationId={selectedId} name={"website"}>
                  <RefTextInput
                    name={`referralLocations[${index}].location.website`}
                    label="Website URL"
                    placeholderText="Website URL"
                    isInitialLoad={isInitialLoad}
                    disabled={isLoading || isReadOnly}
                    required={
                      !!values.referralLocations[index].location.virtual
                    }
                    helpText="The web URL for this location"
                  />
                </GetFormField>
              </div>
              <div>
                <Button
                  type="button"
                  className={`${refEntityStyles.webButton} ${refEntityStyles.button}`}
                  style={{ width: "40px" }}
                  onClick={() => {
                    let url = values.referralLocations[index].location.website

                    if (!url.includes("http")) {
                      url = `https://${url}`
                    }

                    window.open(url, "_blank", "noopener noreferrer")
                  }}
                  disabled={
                    isLoading ||
                    values.referralLocations.length === 0 ||
                    !values.referralLocations[index].location.website
                  }
                >
                  <span className="material-icons">{"language"}</span>
                </Button>
              </div>
            </div>
            <GetFormField locationId={selectedId} name={"ServiceType"}>
              <ReferralEntityFormLocationsCategories
                isLoading={isLoading || isReadOnly}
                referralLocationIndex={index}
                serviceCategories={serviceCategories}
              />
            </GetFormField>

            {!!values?.referralLocations[index] &&
            !values.referralLocations[index].location.virtual ? (
              <RefCheckBox
                name={`referralLocations[${index}].location.noAddress`}
                label="No physical address available"
                disabled={isLoading || isReadOnly}
                helpText="Check this option if no physical address is available for the location."
              />
            ) : null}
          </div>

          {!!values?.referralLocations[index] &&
          !values?.referralLocations[index]?.location.noAddress &&
          !values.referralLocations[index].location.virtual ? (
            <>
              <div className={refEntityStyles.header}>
                <ReferralEntityFormPlacesInput
                  label="Please search for an address"
                  defaultValue={
                    values.referralLocations[index].location.address +
                    (values.referralLocations[index].location.city
                      ? ", " + values.referralLocations[index].location.city
                      : "") +
                    (values.referralLocations[index].location.state
                      ? ", " + values.referralLocations[index].location.state
                      : "") +
                    (values.referralLocations[index].location.zipcode
                      ? ", " + values.referralLocations[index].location.zipcode
                      : "")
                  }
                  isInitialLoad={isInitialLoad}
                  isLoading={isLoading || isReadOnly}
                  locationIndex={index}
                  helpText="Search for the location address to include the global positioning address for referral searches"
                />
                <div className={refEntityStyles.UserHelpMessage}>
                  Please use the address search bar to find the correct address.
                  <br />
                  You may manually enter the address, but please note this may
                  impact geolocation search results when searching for the
                  location in the future
                </div>
              </div>

              <div className={refEntityStyles.AddressFields}>
                <GetFormField
                  locationId={selectedId}
                  name={"address"}
                  highBadge={true}
                >
                  <RefTextInput
                    name={`referralLocations[${index}].location.address`}
                    label="Referral partner address"
                    placeholderText="Address"
                    isInitialLoad={isInitialLoad}
                    disabled={isLoading || isReadOnly}
                    helpText="First line of the location address"
                  />
                </GetFormField>
                <GetFormField
                  locationId={selectedId}
                  name={"city"}
                  highBadge={true}
                >
                  <RefTextInput
                    name={`referralLocations[${index}].location.city`}
                    label=""
                    placeholderText="City"
                    isInitialLoad={isInitialLoad}
                    disabled={isLoading || isReadOnly}
                    helpText="The city in which the location offers services"
                  />
                </GetFormField>
                <GetFormField
                  locationId={selectedId}
                  name={"state"}
                  highBadge={true}
                >
                  <RefDropDown
                    name={`referralLocations[${index}].location.state`}
                    label=""
                    placeHolderValue="Please select a state"
                    options={us_states}
                    disabled={isLoading || isReadOnly}
                    isInitialLoad={isInitialLoad}
                    helpText="The state in which the location offers services"
                  />
                </GetFormField>
                <GetFormField
                  locationId={selectedId}
                  name={"zipcode"}
                  highBadge={true}
                >
                  <RefTextInput
                    name={`referralLocations[${index}].location.zipcode`}
                    label=""
                    placeholderText="Zip code"
                    isInitialLoad={isInitialLoad}
                    disabled={isLoading || isReadOnly}
                    helpText="The zip code in which the location offers services"
                  />
                </GetFormField>
                <GetFormField
                  locationId={selectedId}
                  name={"country"}
                  highBadge={true}
                >
                  <RefDropDown
                    name={`referralLocations[${index}].location.country`}
                    label=""
                    placeHolderValue="Please select a country"
                    options={[
                      { label: "United States", value: "United States" },
                    ]}
                    disabled={isLoading || isReadOnly}
                    isInitialLoad={isInitialLoad}
                    helpText="The country in which the location offers services"
                  />
                </GetFormField>
              </div>
              <div className={refEntityStyles.MapContainer}>
                <ReferralEntityFormMap
                  long={values.referralLocations[index].location.longitude}
                  lat={values.referralLocations[index].location.latitude}
                  setHeight="445px"
                />
              </div>
            </>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
